import Vue from 'vue'

require('./utils/sentry')

import vuetify from './plugins/vuetify'

import i18n from './i18n'

import moment from 'moment'
moment.locale(i18n.locale)

Vue.use(require('vue-moment'), { moment })

import VueTimeago from 'vue-timeago'
Vue.use(VueTimeago, {
  locale: i18n.locale,
  locales: {
    'en': require('date-fns/locale/en'),
    'pl': require('date-fns/locale/pl'),
  }
})

import App from './App.vue'
const title = document.getElementsByTagName('title')[0].innerText
const app = document.getElementById('app')
const auth = document.getElementById('auth')
if(app) {
  const store = require('./store').default
  const router = require('./router').default
  const data = JSON.parse(app.getAttribute('data-init'))
  const { notifications, vapid, now } = data
  delete data.notifications
  delete data.vapid
  store.dispatch('setNow', now)
  store.dispatch('auth/setStatus', data)
  store.dispatch('webpush/status', { vapid, subscribed: data.settings ? data.settings.webpush : false })
  store.dispatch('entities/notifications/status', notifications)
  new Vue(Vue.util.extend({
    vuetify,
    router,
    store,
    title,
    i18n,
    el: app
  }, App))
}
else
if(auth) {
  Vue.use(require('vuetify'))
  const app = new Vue({
    vuetify,
    el: auth,
  });
}
